import { setError } from "@/store/errorSlice";
import { Dispatch } from "@reduxjs/toolkit";

interface ApiError {
  message?: string;
  code?: string | number;
  config?: {
    url?: string;
  };
  response?: {
    data?: any;
    status?: number;
    statusText?: string;
    config?: {
      url?: string;
    };
  };
}

export const handleApiError = (
  error: ApiError,
  source: string,
  dispatch: Dispatch
) => {
  const message =
    error.message ||
    error.response?.data?.message ||
    error.response?.statusText ||
    "An unknown error occurred";

  const code = (error.code || error.response?.status || 500).toString();
  const apiRoute = error.config?.url || error.response?.config?.url;

  dispatch(
    setError({
      message,
      code,
      source,
      timestamp: Date.now(),
      apiRoute,
    })
  );

  // You can also log errors to your monitoring service here
  console.error(`Error in ${source}:`, error);
};
